<template>
	<div class="partners  container">
		<div v-html="description" class="partners__title"></div>
		<div class="partners__logos ">
			<a v-for="(item, key) in logoComp" :key="key + 'logo'" :href="item.action" target="_blank"
				><img :src="item.src" :alt="item.alt" class="partners__logo"
			/></a>
		</div>
	</div>
</template>

<script>
import Marked from 'marked'

export default {
	props: {
		content: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		logoComp() {
			return this.content.logos.map(item => {
				return {
					action: item.customData.link,
					alt: item.alt,
					src: item.url,
				}
			})
		},
		description() {
			return Marked(this.content.description, true)
		},
	},
	components: {},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.partners {
	&__title {
		text-align: center;
		padding-bottom: 1.5rem;
	}
	&__logos {
		display: grid;
		grid-gap: 2rem 3rem;
		justify-content: center;
		align-items: center;

		grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
		@include respond-below('phone') {
			grid-gap: 2rem 1rem;
		}
	}
}
</style>
